import { SessionActionTypes, BaseMapObject } from './types';
import { action } from 'typesafe-actions';
import { NotificationKind } from 'carbon-components-react';
import { v4 as UUIDV4 } from 'uuid';

export const setUserSession = (user: any) =>
  action(SessionActionTypes.SET_USER_SESSION, user);

export const setAuthenticated = (value: boolean) =>
  action(SessionActionTypes.SET_AUTHENTICATED, value);

export const startSession = (value?: number) =>
  action(SessionActionTypes.SESSION_START, value);

export const endSession = () => action(SessionActionTypes.SESSION_END);

export const setScreenSize = (value: string) =>
  action(SessionActionTypes.SET_SCREEN_SIZE, value);

export const setBaseMap = (baseMap: BaseMapObject | undefined) =>
  action(SessionActionTypes.SET_BASE_MAP, baseMap);

export const setActivateIdle = (flag: boolean) =>
  action(SessionActionTypes.SET_ACTIVATE_IDLE, flag);

export const setSysAdminMode = (flag: boolean) =>
  action(SessionActionTypes.SET_SYSADMIN_MODE, flag);

export const setMaintenance = (value: boolean) =>
  action(SessionActionTypes.SET_MAINTENANCE, value);

export const toggleShowHide = () => action(SessionActionTypes.TOGGLE_SHOW_HIDE);

export const addAlert = (
  kind: NotificationKind = 'info',
  message: string = '',
  details: any = '',
  isSystemAlert: boolean = false,
  timeout: number = 10000,
  fixId: string = ''
) => {
  const alert = {
    kind,
    message,
    details,
    id: fixId || UUIDV4(),
    isSystemAlert,
    timeout
  };
  return action(SessionActionTypes.ADD_ALERT, alert);
};
export const removeAlert = (id: string) =>
  action(SessionActionTypes.REMOVE_ALERT, id);
export const removeAllAlerts = (removeSystemAlert: boolean = false) =>
  action(SessionActionTypes.REMOVE_ALL_ALERTS, removeSystemAlert);

export const addNotification = (id: string, data: any) => {
  const notification = {
    id,
    data
  };
  return action(SessionActionTypes.ADD_NOTIFICATION, notification);
};
export const removeNotification = (id: string) =>
  action(SessionActionTypes.REMOVE_NOTIFICATION, id);

export const showOrganisationSuspendedModal = (showModal: boolean = false) =>
  action(SessionActionTypes.SHOW_ORGANISATION_SUSPENDED_MODAL, showModal);

export const fetchUserStart = (data?: any) =>
  action(SessionActionTypes.FETCH_USER_START, data);
export const fetchUserSuccess = () =>
  action(SessionActionTypes.FETCH_USER_SUCCESS);
export const fetchUserFailure = (error: any) =>
  action(SessionActionTypes.FETCH_USER_FAILURE, error);

export const updateUserStart = (data: any) =>
  action(SessionActionTypes.UPDATE_USER_START, data);
export const updateUserSuccess = () =>
  action(SessionActionTypes.UPDATE_USER_SUCCESS);
export const updateUserFailure = (error: any) =>
  action(SessionActionTypes.UPDATE_USER_FAILURE, error);

export const authenticationStart = (token: string) =>
  action(SessionActionTypes.AUTHENTICATION_START, token);
export const authenticationSuccess = () =>
  action(SessionActionTypes.AUTHENTICATION_SUCCESS);
export const authenticationFailure = (error: string) =>
  action(SessionActionTypes.AUTHENTICATION_FAILURE, error);

export const loadCustomBaseMapStart = (data: any) =>
  action(SessionActionTypes.LOAD_CUSTOM_BASEMAP_START, data);
export const loadCustomBaseMapSuccess = (data: any) =>
  action(SessionActionTypes.LOAD_CUSTOM_BASEMAP_SUCCESS, data);
export const loadCustomBaseMapFailure = (error: string) =>
  action(SessionActionTypes.LOAD_CUSTOM_BASEMAP_FAILURE, error);

export const mailboxUnmatchedCountStart = () =>
  action(SessionActionTypes.MAILBOX_UNMATCHED_COUNT_START);
export const mailboxUnmatchedCountSuccess = (data: any) =>
  action(SessionActionTypes.MAILBOX_UNMATCHED_COUNT_SUCCESS, data);
export const mailboxUnmatchedCountFailure = (error: string) =>
  action(SessionActionTypes.MAILBOX_UNMATCHED_COUNT_FAILURE, error);
export const fetchAlertNotificationStatusStart = () =>
  action(SessionActionTypes.FETCH_ALERT_NOTIFICATION_STATUS_START);
export const fetchAlertNotificationStatusSuccess = (isEnvVar: boolean) =>
  action(SessionActionTypes.FETCH_ALERT_NOTIFICATION_STATUS_SUCCESS, isEnvVar);
export const fetchAlertNotificationStatusFailure = (error: any) =>
  action(SessionActionTypes.FETCH_ALERT_NOTIFICATION_STATUS_FAILURE, error);
